"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _datepicker = require("@react-aria/datepicker");
var _DateField = require("../../../components/controls/datepicker/supportcomponents/DateField");
var _RangeCalendar = require("./supportcomponents/RangeCalendar");
var _DatePickerDialog = require("./supportcomponents/DatePickerDialog");
var _FlexRow = require("../../../components/layout/flex/FlexRow");
var _react = _interopRequireWildcard(require("react"));
var _AriaPopover = require("../../../shared/aria-support-components/AriaPopover");
var _ControlWrapper = require("../../../shared/aria-support-components/ControlWrapper.styled");
var _hooks = require("./supportcomponents/hooks");
var _DatePicker = require("../../../components/controls/datepicker/DatePicker");
var _Icon = require("../../media/icon/Icon");
var _globalTokenUtil = require("../../../shared/global-token-util");
var _InfoDisplayWrapper = require("../../../shared/utility-components/InfoDisplayWrapper");
var _input = require("../../../components/inputs/input/input.tokens");
var _BaseButton = require("../buttons/BaseButton");
var _ForecastLocaleProvider = require("../../../../locale/ForecastLocaleProvider");
var _InnerButton = require("../buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
function getShowError(validationState, forceError, suppressError) {
  return !suppressError && (validationState === 'invalid' || forceError);
}
function DateRangePicker(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    minValue = _ref.minValue,
    maxValue = _ref.maxValue,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    size = _ref.size,
    offset = _ref.offset,
    label = _ref.label,
    helperText = _ref.helperText,
    errorText = _ref.errorText,
    suppressError = _ref.suppressError,
    dataCy = _ref['data-cy'],
    ariaLabel = _ref['aria-label'],
    width = _ref.width;
  var _ref2 = (0, _hooks.useDateRangePickerIsoDateState)({
      startDate: startDate,
      endDate: endDate,
      minValue: minValue,
      maxValue: maxValue,
      onChange: onChange
    }),
    ariaState = _ref2.ariaState,
    convertedProps = _ref2.convertedProps;
  var fixedWidth = width !== 'flex';
  var DateRangePickerWrapper = fixedWidth ? _FlexRow.FlexRow : 'div';
  var forceError = !!errorText;
  var datepickerProps = _objectSpread({
    error: forceError,
    'aria-label': ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : label,
    disabled: disabled
  }, convertedProps);
  var ref = (0, _react.useRef)();
  var triggerRef = (0, _react.useRef)();
  var _ref3 = (0, _datepicker.useDateRangePicker)(datepickerProps, ariaState, ref),
    labelProps = _ref3.labelProps,
    groupProps = _ref3.groupProps,
    startFieldProps = _ref3.startFieldProps,
    endFieldProps = _ref3.endFieldProps,
    dialogProps = _ref3.dialogProps,
    calendarProps = _ref3.calendarProps,
    buttonProps = _ref3.buttonProps;
  var showError = getShowError(ariaState.validationState, forceError, suppressError);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ForecastLocaleProvider.ForecastLocaleProvider, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InfoDisplayWrapper.InfoDisplayWrapper, {
      label: label,
      helperText: helperText,
      ariaLabelProps: labelProps,
      errorText: errorText,
      "data-cy": dataCy,
      fixedWidth: fixedWidth,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(DateRangePickerWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ControlWrapper.StyledControlWrapper, _objectSpread({
          rightIcon: true,
          height: size,
          hasError: showError,
          ref: ref,
          width: 'flex',
          "data-cy": dataCy
        }, groupProps, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FlexRow.FlexRow, {
            gap: 'xs',
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DateField.DateField, _objectSpread({}, startFieldProps, {
              "data-cy": 'start-date'
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              icon: 'arrowRight'
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DateField.DateField, _objectSpread({}, endFieldProps, {
              "data-cy": 'end-date'
            }))]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.LeftBorderWrapper, {
            size: size,
            hasError: showError,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerButton.InnerButton, _objectSpread({}, buttonProps, {
              width: _input.tokens.size.height[size],
              height: _input.tokens.size.innerHeight[size],
              emphasis: _BaseButton.EMPHASIS.MEDIUM,
              buttonRef: triggerRef,
              "data-cy": 'open-calendar',
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                icon: 'calendar'
              })
            }))
          })]
        }))
      }), ariaState.isOpen ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_AriaPopover.AriaPopover, {
        state: ariaState,
        triggerRef: ref,
        offset: (0, _globalTokenUtil.getOffsetAsNumber)(offset),
        placement: "bottom left",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePickerDialog.DatePickerDialog, {
          ariaDialogProps: dialogProps,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_RangeCalendar.RangeCalendar, _objectSpread({}, calendarProps))
        })
      }) : null]
    })
  });
}
DateRangePicker.defaultProps = {
  size: _DatePicker.DATE_PICKER_SIZE.LARGE,
  error: false,
  disabled: false,
  suppressError: false,
  offset: 'xl'
};
var _default = exports.default = DateRangePicker;